export default __webpack_public_path__ + "static/media/Robot.a583af27.png";